import { ref } from 'vue'
import { AxiosInstance } from 'axios'
import {ContentStatisticsDocument, getHotContent} from '/@src/api/searchRepo'
import useApi, {useApollo} from "/@src/composable/useApi";
import {Content, Exact, Maybe, Scalars} from "/@src/models/graphApi";
import {FindContentDocument} from "/@src/api/contentRepo";
import {FindContentQuery, FindContentQueryVariables} from "/@src/composable/content/useContent";
import {toISOLocal} from "/@src/utils/date";

export type ContentStatisticsQueryVariables = Exact<{
  size?: Maybe<Scalars['Int']>;
  day?: Maybe<Scalars['Timestamp']>;
}>;


export type ContentStatisticsQuery = { __typename?: 'query', daily_topk?: Array<{ __typename?: 'Content', cover_url?: string | null | undefined, datetime?: any | null | undefined, kind?: number | null | undefined, raw_id?: number | null | undefined, title?: string | null | undefined, description?: string | null | undefined, vip_visibility?: number | null | undefined, author?: { __typename?: 'Author', id?: number | null | undefined, nickname?: string | null | undefined, avatar?: string | null | undefined } | null | undefined, counter?: { __typename?: 'Counter', viewed?: number | null | undefined } | null | undefined } | null | undefined> | null | undefined };

export default function useSearchHotContent() {
  const response = ref<SearchHotContent>()
  const api = useApi()
  const graph = useApollo()
  const hotContents = ref<Array<Content>>()
  const getSearchHotContent = async () => {
    const ret = await getHotContent(api)
    response.value = ret
  }
  const queryTodayHotContent = async ()=>{
    const today = new Date()
    today.setHours(0,0,0,0)
    const  res = await graph.query<ContentStatisticsQuery, ContentStatisticsQueryVariables>({query:ContentStatisticsDocument
      ,variables: {
        day:toISOLocal(today),
        size:8
      }})
    if(res.data.daily_topk){
      hotContents.value = res.data.daily_topk as Array<Content>
    }
  }
  return {
    response,
    getSearchHotContent,
    hotContents,
    queryTodayHotContent
  }
}
